module.exports = __webpack_public_path__ + "img/_ABS9788(1).6cba8b04.jpg";